// extracted by mini-css-extract-plugin
module.exports = {"dataTableFormat":"styles_dataTableFormat__TJJV0","formSpace":"styles_formSpace__25JMD"};